module.exports = __webpack_public_path__ + "img/midjourney.1ba2676d.png";